import jsPDF from 'jspdf';
import authFetch from './authFetch';
import html2canvas from 'html2canvas';

// Rendre disponibles globalement
window.jsPDF = { jsPDF };
window.html2canvas = html2canvas;

export async function exportCvToPdf(cvData, cvStyle, template, token) {
    try {
        // Validation des données avant envoi
        if (!cvData || !cvData.personalInfo) {
            throw new Error('Données CV manquantes');
        }
        
        if (!template) {
            throw new Error('Template manquant');
        }
        
        if (!token) {
            throw new Error('Token d\'authentification manquant');
        }

        console.log('Données envoyées pour export PDF:', {
            cvData: {
                personalInfo: cvData.personalInfo,
                summary: cvData.summary,
                experience: cvData.experience?.length || 0,
                skills: cvData.skills?.length || 0
            },
            cvStyle,
            template: template.id
        });

        const response = await authFetch('https://cvanalyzerback.osc-fr1.scalingo.io/api/cv/export-pdf-from-data', {
            method: 'POST',
            body: JSON.stringify({
                cvData,
                cvStyle,
                template,
                format: 'pdf'
            })
        });

        console.log('Réponse serveur:', {
            status: response.status,
            statusText: response.statusText,
            contentType: response.headers.get('content-type')
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Erreur serveur détaillée:', errorText);
            throw new Error(`Erreur HTTP ${response.status}: ${response.statusText}. Détails: ${errorText}`);
        }

        // Vérifier le type de contenu retourné
        const contentType = response.headers.get('content-type');
        
        if (contentType && contentType.includes('text/html')) {
            // Mode production : HTML retourné
            const htmlContent = await response.text();
            console.log('HTML reçu du serveur, conversion en PDF...');
            return await convertHtmlToPdf(htmlContent);
        } else {
            // Mode développement : PDF retourné directement
            const pdfBlob = await response.blob();
            console.log('PDF reçu directement du serveur');
            return pdfBlob;
        }

    } catch (error) {
        console.error('Erreur lors de l\'export PDF:', error);
        throw error;
    }
}

// Fonction pour convertir HTML en PDF côté client
async function convertHtmlToPdf(htmlContent) {
    // Option 1 : Utiliser jsPDF avec html2canvas
    if (typeof window !== 'undefined' && window.jsPDF) {
        return await convertWithJsPDF(htmlContent);
    }
    
    // Option 2 : Utiliser window.print() pour imprimer en PDF
    return await convertWithPrint(htmlContent);
}

// Option 1 : jsPDF + html2canvas
async function convertWithJsPDF(htmlContent) {
    const { jsPDF } = window.jsPDF;
    const html2canvas = window.html2canvas;
    
    // Créer un élément temporaire avec le HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = '-9999px';
    tempDiv.style.top = '0';
    tempDiv.style.width = '794px'; // A4 width
    tempDiv.style.backgroundColor = '#ffffff';
    tempDiv.style.padding = '20px';
    document.body.appendChild(tempDiv);
    
    try {
        const canvas = await html2canvas(tempDiv, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            width: 794, // A4 width in pixels at 96 DPI
            height: 1123 // A4 height in pixels at 96 DPI
        });
        
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        
        // Ajouter la première page
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        
        // Ajouter des pages supplémentaires si nécessaire
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }
        
        return pdf.output('blob');
    } finally {
        document.body.removeChild(tempDiv);
    }
}

// Option 2 : window.print()
async function convertWithPrint(htmlContent) {
    return new Promise((resolve) => {
        // Créer une nouvelle fenêtre avec le HTML
        const printWindow = window.open('', '_blank');
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        
        printWindow.onload = () => {
            printWindow.print();
            printWindow.close();
            resolve(null); // Pas de blob retourné, l'utilisateur imprime
        };
    });
}

// Fonction utilitaire pour télécharger un blob
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
} 